import React from "react";

/**
 * Error Boundary to catch DOM errors caused by Google Translate.
 *
 * Google Translate (browser extension) rewrites text nodes replacing them
 * with <font> elements. React then tries to call insertBefore() on a reference
 * node that is no longer a direct child of the parent, throwing a NotFoundError.
 *
 * When that specific error is caught, we force a remount by incrementing the
 * key, which resets the subtree to a clean state.
 */
class GoogleTranslateErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mountKey: 0 };
  }

  static getDerivedStateFromError(error) {
    const isInsertBeforeError =
      error instanceof Error &&
      (error.message || "").includes("insertBefore");

    if (isInsertBeforeError) {
      return null; // handled in componentDidCatch
    }

    throw error; // re-throw unrelated errors so other boundaries can handle
  }

  componentDidCatch(error) {
    const isInsertBeforeError =
      error instanceof Error &&
      (error.message || "").includes("insertBefore");

    if (isInsertBeforeError) {
      // Force remount of the subtree to recover from the DOM inconsistency
      this.setState((prev) => ({ mountKey: prev.mountKey + 1 }));
    }
  }

  render() {
    return (
      <React.Fragment key={this.state.mountKey}>
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default GoogleTranslateErrorBoundary;
